var Queensland = "昆士兰州";
var Tasmania = "塔斯马尼亚州";
var Victoria = "维多利亚州";
var AUStates = {
	"Australian Capital Territory": "澳大利亚首都直辖区",
	"New South Wales": "新南威尔士州",
	"Northern Territory": "北领地",
	Queensland: Queensland,
	"South Australia": "南澳大利亚州",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "西澳大利亚州"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
